<template>
  <div class="static">
    <div class="navigation">
      <nav class="navbar is-link" role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <router-link class="navbar-item" to="/" active-class="">
              <strong class="is-size-4">thread</strong>
            </router-link>
          </div>
          <div class="navbar-always">
            <div class="navbar-end">

              <div class="navbar-item">
                <router-link class="button is-white is-outlined" to="/app/">
                  <span class="icon is-small"><i class="fas fa-home"></i></span>
                  <span>Go to App</span>
                </router-link>
              </div>

            </div>

          </div>

        </div>
      </nav>
    </div>

    <div class="mb-5">
      <router-view/>
    </div>

    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          Thread by <a class="has-text-link" href="https://chalkstream.dev">Chalkstream Development</a>.
          &#169; 2021 - 2022 All rights reserved.
        </p>
        <p class="has-opacity-50">
          <router-link to="/">homepage</router-link> &bull;
          <router-link to="/privacy">privacy policy</router-link> &bull;
          <router-link to="/terms">terms of service</router-link>
        </p>
      </div>
    </footer>


  </div>
</template>

<script>
export default {
  name: "Static.vue"
}
</script>

<style scoped lang="scss">

.navbar {
  .container {
    display: flex !important;
  }
}

.navbar-always {
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-shrink: 0;

  .navbar-end {
    align-items: stretch;
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  }
}

</style>
